import React, { memo } from 'react';
import { AccordionButtonProps } from '@chakra-ui/accordion';
import { CustomAccordionButton } from './styles';
import { CustomIcon } from 'components';
import { Box } from '@chakra-ui/react';

interface IProps extends AccordionButtonProps {
  iconOnLeft?: boolean;
}

const AccordionHeaderComponent: React.FC<IProps> = ({ children, iconOnLeft, ...props }) => {
  return (
    <CustomAccordionButton
      {...props}
      padding="0"
      _focus={{ boxShadow: 'none' }}
      color="brand.900"
      border="none"
    >
      {iconOnLeft && (
        <Box ml="auto">
          <CustomIcon
            className="icon"
            $noSphere
            icon="chevron_down"
            size="24px"
            color="brand.primary"
          />
        </Box>
      )}
      {children}
      {!iconOnLeft && (
        <Box ml="auto" mr="1rem">
          <CustomIcon
            className="icon"
            $noSphere
            icon="chevron_down"
            size="24px"
            color="brand.black700"
          />
        </Box>
      )}
    </CustomAccordionButton>
  );
};

export const AccordionHeader = memo(AccordionHeaderComponent);
